var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 12,
  viewBox: "0 0 36 12",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.76837e-07 6.00001L5.625 0.214292L6.67929 1.22729L2.67171 5.27663L36 5.27663V6.72339L2.67171 6.72339L6.60986 10.7727L5.625 11.7857L4.76837e-07 6.00001Z",
  fill: "black"
})));
export default SvgIconArrow;